import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2, Ban } from "lucide-react";
import { auth } from "@/firebase/config";
import { signOut } from "firebase/auth";

function BannedScreen({ reason }: { reason?: string }) {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-gradient-to-br from-red-950 via-red-900 to-black p-6 text-center">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(239,68,68,0.25),transparent_70%)]" />
      <div className="relative flex flex-col items-center">
        <div className="mb-6 grid h-24 w-24 place-items-center rounded-3xl border border-red-400/40 bg-red-500/20 shadow-[0_0_60px_rgba(239,68,68,0.5)]">
          <Ban className="h-12 w-12 text-red-300" />
        </div>
        <h1 className="font-headline text-4xl font-black text-red-100 md:text-5xl">Cuenta baneada</h1>
        <p className="mt-4 max-w-md text-red-200/80">
          Tu cuenta ha sido suspendida y no puedes acceder a Jartinet.
        </p>
        {reason && (
          <div className="mt-5 max-w-md rounded-2xl border border-red-400/30 bg-red-500/10 px-5 py-3 text-sm text-red-100">
            <span className="font-semibold">Motivo:</span> {reason}
          </div>
        )}
        <p className="mt-6 text-xs text-red-300/60">
          Si crees que es un error, contacta con la administración.
        </p>
        <button
          onClick={() => signOut(auth)}
          className="mt-8 rounded-xl border border-red-400/30 bg-red-500/10 px-6 py-2.5 text-sm font-semibold text-red-100 transition-colors hover:bg-red-500/20"
        >
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}

export default function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { user, userData, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Loader2 className="h-12 w-12 animate-spin text-primary" />
      </div>
    );
  }

  if (!user || user.isAnonymous) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to. This allows us to send them back after login.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Usuario baneado: bloqueo total de Jartinet desde cualquier ruta.
  if (userData?.banned) {
    return <BannedScreen reason={userData.banReason} />;
  }

  return children;
}
